import { SHOW_SUCCESS, SHOW_WARNING, SHOW_ERROR } from '../actions/actionTypes';

const initialState = {
    success: '',
    error: '',
    warning: '',
};

export const toasterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_SUCCESS:
            return {
                ...state,
                success: action.payload,
            };
        case SHOW_WARNING:
            return {
                ...state,
                warning: action.payload,
            };
        case SHOW_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};
